import { PrismicRichText } from "@prismicio/react";
import * as PropTypes from "prop-types";

import { unstyledRichTextComponents } from "@up/ui";

const RichText = function ({ field }) {
  return (
    <PrismicRichText field={field} components={unstyledRichTextComponents()} />
  );
};

RichText.propTypes = {
  render: PropTypes.array,
};

export default RichText;
